import classnames from "classnames";
import { actions as advActions } from "components/advertising/logic/formActions";
import Select from "components/common/Select";
import { assertObject, assertString, validArray } from "core/validation";
import { debounce, get } from "lodash";
import log from "loglevel";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import envconfig from "../../../envconfig";
import {DATE_FORMAT_ONLY_YEAR, formatDate} from "components/common/dateUtils";

export function formatOptionLabel(props, state) {
    return (
        <div style={{ display: "flex", flexDirection: "column", padding: "4px 10px", fontSize: 12 }}>
            <div style={{ display: "flex", flex: 1, fontSize: 14, fontWeight: 500 }}>{props.label}</div>
            {state.context === "menu" && (
                <div style={{ display: "flex", flex: 1 }}>
                    {}
                    <div style={{ display: "flex", flex: "6", opacity: 0.6 }}>{props.company}</div>
                    <div style={{ display: "flex", flex: "1", opacity: 0.6 }}>{props.ratingType}</div>
                    <div style={{ display: "flex", flex: "1", opacity: 0.6 }}>{props.releaseType}</div>
                    <div style={{ display: "flex", flex: "1", opacity: 0.6 }}>{props.relDate}</div>
                    {}
                </div>
            )}
        </div>
    );
}

formatOptionLabel.propTypes = {
    label: PropTypes.string,
    company: PropTypes.string,
    ratingType: PropTypes.string,
    releaseType: PropTypes.string,
    relDate: PropTypes.string,
};

class FilmReleaseSelect extends Component {
    constructor(props) {
        super(props);
        this.getFilmByTitle = debounce(this.props.getFilmByTitle, 300);
        log.debug("[FILM RELEASE SELECT CONSTRUCTOR ", props.defaultInputValue);
    }

    state = {
        filmRelease: false,
        filmValue: this.props.defaultInputValue || "",
    };

    componentDidUpdate({ defaultInputValue, titleSuggestion }) {
        if (!defaultInputValue && this.props.defaultInputValue) {
            this.setState({
                filmValue: this.props.defaultInputValue,
            });
        }
        if (titleSuggestion !== this.props.titleSuggestion) {
            if (assertString(this.props.titleSuggestion)) {
                this.getFilmByTitle({ titlePattern: this.props.titleSuggestion });
            }
            this.setState({
                filmValue: this.props.titleSuggestion,
            });
        }
    }

    filmSelectStyle = {
        menuList: (provided) => ({
            ...provided,
            minHeight: 600,
        }),
        menu: (provided) => ({
            ...provided,
            minHeight: 600,
        }),
    };

    onInput = (e, a) => {
        if (a && a.action === "input-blur") {
            if (this.props.keepInputText && this.props.onBlur) {
                this.props.onBlur(e, this.state.filmValue);
            }
            return;
        }
        if (a && a.action === "menu-close") return;

        if (this.props.keepInputText) this.setState({ filmValue: e.target.value });
        if (e.target.value.length > envconfig.MAX_CHARACTERS_SEARCH_INPUT)
            this.getFilmByTitle({
                titlePattern: e.target.value,
            });
    };

    onKeyDown = (e) => {
        if (e.keyCode === 13) {
            this.getFilmByTitle({
                titlePattern: this.state.filmValue,
            });
        }
    };

    render() {
        const { filmTitles, loadFilmTitles, onChange, value, defaultOptions, placeholder, formikBag, multiple, ...props } =
            this.props;

        const filmTls = filmTitles.map((fTitle) => ({
            value: fTitle.id,
            label: fTitle.title,
            company: fTitle.companyId.title,
            ratingType: get(fTitle, "filmRatingTypeId.abbreviation", ""),
            releaseType: get(fTitle, "filmReleaseTypeId.abbreviation", ""),
            relDate: fTitle.releaseDate
                ? formatDate(fTitle.releaseDate, DATE_FORMAT_ONLY_YEAR)
                : formatDate(fTitle.enteredDate, DATE_FORMAT_ONLY_YEAR),
            ...fTitle,
        }));

        const _onChange = (option, selectOptions) => {
            if (!assertObject(option) || !assertObject(option.parentReleaseId)) {
                return onChange(option, selectOptions, formikBag);
            } else {
                const { parentReleaseId } = option;
                if (assertObject(parentReleaseId)) {
                    const filmR = {
                        ...parentReleaseId,
                        value: parentReleaseId.id,
                        label: parentReleaseId.title,
                    };
                    return onChange(filmR, selectOptions, formikBag);
                }
            }
        };

        return (
            <Select
                placeholder={placeholder || "Select or type release"}
                className={classnames("film-release-select", this.props.className)}
                value={value}
                onChange={_onChange}
                onInput={(e, a) => this.onInput({ target: { value: e, name: "filmRelease" } }, a)}
                onKeyDown={this.onKeyDown}
                options={filmTls || defaultOptions}
                styles={validArray(filmTls) ? this.filmSelectStyle : {}}
                formatOptionLabel={formatOptionLabel}
                loading={loadFilmTitles === "SEND"}
                inputValue={this.state.filmValue || undefined}
                multiple={multiple}
                {...props}
            />
        );
    }
}

FilmReleaseSelect.propTypes = {
    className: PropTypes.string,
    defaultInputValue: PropTypes.string,
    defaultOptions: PropTypes.array,
    filmTitles: PropTypes.array,
    formikBag: PropTypes.object,
    keepInputText: PropTypes.bool,
    loadFilmTitles: PropTypes.string,
    multiple: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    titleSuggestion: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    getFilmByTitle: PropTypes.func,
};

const mapStateToProps = ({ advertising: { filmTitles, loadFilmTitles } }) => ({
    filmTitles,
    loadFilmTitles,
});

const mapDispatchToProps = (dispatch) => ({
    clearForm: () => dispatch(advActions.CLEAR_FORM.call()),
    getFilmByTitle: (payload) => dispatch(advActions.GET_FILM_TITLE.send(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilmReleaseSelect);
